import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import type * as React from "react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Keyboard-activation handler for elements made clickable via `onClick` on a
 * non-button (e.g. a clickable row or chip given `role="button"`). Activates on
 * Enter/Space (and suppresses the default Space-scroll), matching native button
 * semantics. Shared so the picker rows, data-table rows etc. don't each re-spell
 * the same handler. */
export function activateOnEnterSpace(handler: () => void) {
  return (e: React.KeyboardEvent): void => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handler();
    }
  };
}
